<template>
  <v-dialog
    v-model="visibleDialog"
    persistent
    width="290"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="formattedDateRange"
        :label="label"
        :placeholder="placeholder"
        prepend-inner-icon="mdi-calendar-range"
        readonly
        outlined
        clearable
        dense
        hide-details
        v-on="on"
        @click:clear="clear"
      ></v-text-field>
    </template>
    <v-date-picker v-model="dateRange" range>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="cancel">Cancelar</v-btn>
      <v-btn text color="primary" @click="save(dateRange)" :disabled="dateRange.length !== 2">Seleccionar</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import { formatDateRange, sortDateRange } from '../utils'

export default {
  props: {
    returnValue: Array,
    editRange: null,
    label: String,
    placeholder: {
      type: String,
      default: 'Seleccione un intervalo...'
    }
  },

  data: () => ({
    visibleDialog: false,
    dateRange: []
  }),

  computed: {
    formattedDateRange () {
      // informacion a mostrar en el campo
      if (this.dateRange.length) {
        let sorted = sortDateRange(this.dateRange)
        return formatDateRange(sorted).join('  -  ')
      } else {
        return []
      }
    }
  },

  methods: {
    save (value) {
      this.$emit('update:returnValue', value)
      this.visibleDialog = false
    },
    cancel () {
      this.dateRange = this.returnValue
      this.visibleDialog = false
    },
    clear () {
      this.dateRange = []
      this.$emit('update:returnValue', [])
    }
  },
  watch: {
    returnValue: function (val) {
      if (val != null && this.editRange) {
        this.dateRange = val
      }
    }
  }
}
</script>

<style scoped>

</style>
